// Libraries
var React = require("react");

// Components
var GenericRichText = require("../RichText/GenericRichText");

// Style
require("./TaglineText.scss");

class TaglineTextModule extends React.Component {

    render() {
        return (
            <div id={this.props.data.id}>
                {this.props.data.blocks.map((item, index) => {
                    return (
                        <div
                            className={`c-section c-section--gutter c-tagline-text ${this.props.data.isPremium ? " c-tagline-text--premium" : ""
                                }
              ${item.alignTitleRight ? " c-tagline-text--right" : ""}
              `}
                            key={index}
                        >
                            <div className="c-section__inner">
                                <div className="c-tagline-text__inner">
                                    <div className="c-tagline-text__title-container">
                                        <h2 className="c-tagline-text__title">
                                            {item.title}
                                        </h2>
                                    </div>
                                    <div className="c-tagline-text__content">
                                        <GenericRichText
                                            content={item.text}
                                            isPremium={this.props.data.isPremium}
                                            largeText={true}
                                        />
                                        {item.link && item.link.url && item.link.caption ? (
                                            <div className="c-tagline-text__button-container">
                                                <a
                                                    href={item.link.url}
                                                    className={`c-button ${this.props.data.isPremium ? "c-button--premium" : ""
                                                        }`}
                                                    target={
                                                        item.link.newWindow ? "_blank" : "_self"
                                                    }
                                                    rel={
                                                        item.link.newWindow
                                                            ? "noopener noreferrer"
                                                            : undefined
                                                    }
                                                >
                                                    {item.link.caption}
                                                </a>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="c-tagline-text__footer">
                                        {item.infoSection.length ? (
                                            <div className="c-tagline-text__info-section">
                                                {item.infoSection.map(
                                                    (openingTime, index) => {
                                                        return (
                                                            <div key={index} className="c-tagline-text__info">
                                                                <p className="c-tagline-text__info-title">
                                                                    {openingTime.title}
                                                                </p>
                                                                <p className="c-tagline-text__info-text">
                                                                    {openingTime.text}
                                                                </p>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        ) : null}
                                        {item.infoSectionFootnote ? (
                                            <p className={`c-tagline-text__info-section-footnote ${!item.infoSection.length ? 'c-tagline-text__info-section-footnote--no-info' : ''}`}>
                                                {item.infoSectionFootnote}
                                            </p>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

module.exports = TaglineTextModule;



// WEBPACK FOOTER //
// ./src/components/TaglineText/TaglineText.js